import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { Resizable } from "react-resizable";
import "react-resizable/css/styles.css"; // Base styles for the resizable component

import {
  FaPlus,
  FaTrash,
  FaSave,
  FaSpinner,
  FaTimes,
  FaFileExcel,
  FaArrowsAltH,
  FaSyncAlt,
  FaSearch,
  FaFilter,
  FaEllipsisV,
} from "react-icons/fa";
import ExcelLikeFilter from "./ExcelLikeFilter";
import {
  getApplicationRecords,
  getAvailableFields,
  addApplicationColumn,
  removeApplicationColumn,
  addApplicationRow,
  updateApplicationRow,
  deleteApplicationRow,
  bulkUpdateApplicationRows,
  bulkInsertApplicationRows,
  bulkDeleteApplicationRows,
  updateSingleRecord,
} from "../../../services/application.services";

const ApplicationData = () => {
  const customers = useSelector((state) => state.customer.customers);
  // const mapApplicationManager = (managerId) => {
  //   const matchedCustomer = customers.find(
  //     (customer) => customer.UserName === managerId
  //   );
  //   return matchedCustomer ? matchedCustomer.UserName : "Not Assigned";
  // };

  // // Modify data to include the mapped Application Manager Name
  // const modifiedData = data.map((row) => ({
  //   ...row,
  //   assigned_application_manager: mapApplicationManager(
  //     row.assigned_application_manager_id
  //   ),
  // }));

  // "Modified Data with Application Manager Names:", modifiedData);

  const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);
  const admins = useSelector((state) => state.admin.admins);

  // State for loading
  const [isLoading, setIsLoading] = useState(false);

  // State for error message
  const [error, setError] = useState(null);

  // State for success message
  const [successMessage, setSuccessMessage] = useState(null);

  // Initial empty columns state - will be populated from API
  const [columns, setColumns] = useState([]);

  // Track fixed and dynamic columns separately
  const [fixedColumns, setFixedColumns] = useState([]);
  const [dynamicColumns, setDynamicColumns] = useState([]);

  // New column name for adding a column
  const [newColumnName, setNewColumnName] = useState("");
  const [showAddColumnModal, setShowAddColumnModal] = useState(false);

  // Initial data
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [editingCell, setEditingCell] = useState(null);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  // State for refresh functionality
  const [refreshKey, setRefreshKey] = useState(0);

  // Track changes for bulk update
  const [changedRows, setChangedRows] = useState(new Set());

  //state for select rows
  // Add this to your existing state declarations
  const [selectedRows, setSelectedRows] = useState(new Set());

  // Add this with your other state declarations
  const [columnWidths, setColumnWidths] = useState({});

  // Fetch data from API when component mounts or refresh is triggered
  useEffect(() => {
    fetchApplicationData();
  }, [refreshKey]);

  // Function to fetch application data from the API
  // const fetchApplicationData = async () => {
  //   setIsLoading(true);
  //   setError(null);
  //   try {
  //     // First get available fields to determine fixed columns
  //     const fields = await getAvailableFields();
  //     const fixedCols = fields
  //       .filter((field) => field !== "id" && field !== "dynamic_fields")
  //       .map((field, index) => {
  //         // Convert snake_case to Title Case for display
  //         const displayName = field
  //           .split("_")
  //           .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
  //           .join(" ");

  //         return {
  //           key: field,
  //           displayName: displayName,
  //           width: field === "sr_no" ? "80px" : "150px",
  //           minWidth: field === "sr_no" ? "80px" : "120px",
  //           priority: index + 1,
  //           isFixed: true,
  //         };
  //       });

  //     setFixedColumns(fixedCols);

  //     // Then get the actual data
  //     const response = await getApplicationRecords();

  //     // Process records to handle dynamic fields
  //     const processedRecords = response.map((record) => {
  //       // Start with the fixed fields
  //       const processedRecord = { ...record };
  //       const assignedAdmin = admins.find(
  //         (admin) => admin.admin_id === record.assigned_aplication_manager
  //       );

  //       // Replace ID with userName if found
  //       processedRecord.assigned_aplication_manager =
  //         processedRecord.assigned_aplication_manager.username;

  //       // Extract dynamic fields and add them directly to the record
  //       if (
  //         record.dynamic_fields &&
  //         typeof record.dynamic_fields === "object"
  //       ) {
  //         Object.keys(record.dynamic_fields).forEach((key) => {
  //           processedRecord[key] = record.dynamic_fields[key];
  //         });
  //       }

  //       return processedRecord;
  //     });

  //     // Extract dynamic column names from the first record with dynamic fields
  //     const firstRecordWithDynamicFields = processedRecords.find(
  //       (r) => r.dynamic_fields && Object.keys(r.dynamic_fields).length > 0
  //     );

  //     let dynColumns = [];
  //     if (firstRecordWithDynamicFields) {
  //       dynColumns = Object.keys(
  //         firstRecordWithDynamicFields.dynamic_fields
  //       ).map((key, index) => ({
  //         key: key,
  //         displayName: key,
  //         width: "150px",
  //         minWidth: "120px",
  //         priority: fixedCols.length + index + 1,
  //         isFixed: false,
  //       }));
  //     }

  //     setDynamicColumns(dynColumns);

  //     // Combine fixed and dynamic columns
  //     const allColumns = [...fixedCols, ...dynColumns];
  //     setColumns(allColumns);

  //     setData(processedRecords);
  //     setOriginalData(processedRecords);
  //   } catch (error) {
  //     console.error("Error fetching application data:", error);
  //     setError("Failed to load application data. Please try again.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  const fetchApplicationData = async () => {
    setIsLoading(true);
    setError(null);
    try {
      // First get available fields to determine fixed columns
      const fields = await getAvailableFields();
      const fixedCols = fields
        .filter((field) => field !== "id" && field !== "dynamic_fields")
        .map((field, index) => {
          // Convert snake_case to Title Case for display
          const displayName = field
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");

          return {
            key: field,
            displayName: displayName,
            width: field === "sr_no" ? "80px" : "150px",
            minWidth: field === "sr_no" ? "80px" : "120px",
            priority: index + 1,
            isFixed: true,
          };
        });

      setFixedColumns(fixedCols);

      // Then get the actual data
      const response = await getApplicationRecords();

      // Process records to handle dynamic fields
      const processedRecords = response.map((record) => {
        // Start with the fixed fields
        const processedRecord = { ...record };

        // Handle assigned_aplication_manager - check if it's already an object or just an ID
        if (processedRecord.assigned_aplication_manager) {
          if (typeof processedRecord.assigned_aplication_manager === "object") {
            // If it's already an object, extract the username
            processedRecord.assigned_aplication_manager =
              processedRecord.assigned_aplication_manager.username ||
              "Not Assigned";
          } else {
            // If it's an ID, find the admin in the admins array
            const assignedAdmin = admins.find(
              (admin) =>
                admin.admin_id === processedRecord.assigned_aplication_manager
            );
            processedRecord.assigned_aplication_manager =
              assignedAdmin?.username || "Not Assigned";
          }
        } else {
          processedRecord.assigned_aplication_manager = "Not Assigned";
        }

        // Extract dynamic fields and add them directly to the record
        if (
          record.dynamic_fields &&
          typeof record.dynamic_fields === "object"
        ) {
          Object.keys(record.dynamic_fields).forEach((key) => {
            processedRecord[key] = record.dynamic_fields[key];
          });
        }

        return processedRecord;
      });

      // Extract dynamic column names from the first record with dynamic fields
      const firstRecordWithDynamicFields = processedRecords.find(
        (r) => r.dynamic_fields && Object.keys(r.dynamic_fields).length > 0
      );

      let dynColumns = [];
      if (firstRecordWithDynamicFields) {
        dynColumns = Object.keys(
          firstRecordWithDynamicFields.dynamic_fields
        ).map((key, index) => ({
          key: key,
          displayName: key,
          width: "150px",
          minWidth: "120px",
          priority: fixedCols.length + index + 1,
          isFixed: false,
        }));
      }

      setDynamicColumns(dynColumns);

      // Combine fixed and dynamic columns
      const allColumns = [...fixedCols, ...dynColumns];
      setColumns(allColumns);

      setData(processedRecords);
      setOriginalData(processedRecords);
    } catch (error) {
      console.error("Error fetching application data:", error);
      setError("Failed to load application data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  // Responsive column visibility
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);

      // Determine visible columns based on screen width
      let columnsToShow;
      const allColumns = [...columns]; // Make a copy to avoid mutation

      // Sort by priority
      allColumns.sort((a, b) => a.priority - b.priority);

      if (screenWidth > 1600) {
        columnsToShow = allColumns;
      } else if (screenWidth > 1400) {
        columnsToShow = allColumns.filter((col) => col.priority <= 9);
      } else if (screenWidth > 1200) {
        columnsToShow = allColumns.filter((col) => col.priority <= 7);
      } else if (screenWidth > 1000) {
        columnsToShow = allColumns.filter((col) => col.priority <= 5);
      } else if (screenWidth > 768) {
        columnsToShow = allColumns.filter((col) => col.priority <= 3);
      } else {
        columnsToShow = allColumns.filter((col) => col.priority <= 2);
      }

      setVisibleColumns(columnsToShow);
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Initial call
    handleResize();

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, [columns]);

  const handleAddRow = async () => {
    // Create new row with empty values
    const newRow = {
      sr_no: `TEMP_${Date.now()}`, // Temporary ID until backend assigns one
      student_name: "",
      university: "",
      updates: "",
      course_name: "",
      current_status: "",
      offer_received_rejected: "",
      location: "",
      partner: "",
      app_fee: "",
      status: "Not applied",
      dynamic_fields: {},
    };

    // Add dynamic field values
    dynamicColumns.forEach((col) => {
      newRow.dynamic_fields[col.key] = "";
    });

    try {
      setIsLoading(true);

      // Add row to data for immediate UI update
      const newData = [...data, newRow];
      setData(newData);
      setOriginalData([...originalData, newRow]);

      // Mark this row as changed
      setChangedRows(new Set(changedRows.add(newData.length - 1)));

      // No immediate API call - this will be sent to the server on save
      setSuccessMessage(
        "New row added. Remember to save changes to persist to server."
      );
      setTimeout(() => setSuccessMessage(null), 3000);
    } catch (error) {
      console.error("Error adding row:", error);
      setError("Failed to add row. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteRow = async (index) => {
    const rowToDelete = data[index];

    try {
      setIsLoading(true);

      // Log the row to understand its structure

      // Check if this is a new row (hasn't been saved to the server yet)
      if (
        rowToDelete.id &&
        typeof rowToDelete.id === "string" &&
        rowToDelete.id.startsWith("TEMP_")
      ) {
        // Just remove it from the local data
        const newData = data.filter((_, idx) => idx !== index);
        setData(newData);
        setOriginalData(newData);
        setSuccessMessage("Temporary row removed.");
        setTimeout(() => setSuccessMessage(null), 3000);
        return;
      }

      // For existing rows, use the ID field
      const rowId = rowToDelete.id;

      if (rowId === undefined || rowId === null) {
        setError("Failed to delete row: Could not determine row ID");
        setIsLoading(false);
        return;
      }

      // Delete from server - using sr_no (singular) as the parameter name
      await bulkDeleteApplicationRows([rowId]);

      // Update local data
      const newData = data.filter((_, idx) => idx !== index);
      setData(newData);
      setOriginalData(newData);

      setSuccessMessage("Row deleted successfully.");
      setTimeout(() => setSuccessMessage(null), 3000);
    } catch (error) {
      console.error("Error deleting row:", error);
      setError(`Failed to delete row: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowAddColumnModal = () => {
    setNewColumnName("");
    setShowAddColumnModal(true);
  };

  const handleAddColumn = async () => {
    if (!newColumnName.trim()) {
      setError("Column name cannot be empty.");
      return;
    }

    try {
      setIsLoading(true);

      // Add column via API
      await addApplicationColumn(newColumnName);

      // Update local column state
      const newDynamicColumn = {
        key: newColumnName,
        displayName: newColumnName,
        width: "150px",
        minWidth: "120px",
        priority: columns.length + 1,
        isFixed: false,
      };

      setDynamicColumns([...dynamicColumns, newDynamicColumn]);
      setColumns([...columns, newDynamicColumn]);

      // Update data with empty values for the new column
      const updatedData = data.map((row) => {
        // Make a shallow copy of the row
        const newRow = { ...row };

        // Ensure dynamic_fields exists
        if (!newRow.dynamic_fields) {
          newRow.dynamic_fields = {};
        }

        // Add the new column with empty value to dynamic_fields
        newRow.dynamic_fields[newColumnName] = "";

        return newRow;
      });

      setData(updatedData);
      setOriginalData(updatedData);
      setShowAddColumnModal(false);
      setSuccessMessage(`Column "${newColumnName}" added successfully.`);
      setTimeout(() => setSuccessMessage(null), 3000);
    } catch (error) {
      console.error("Error adding column:", error);
      setError("Failed to add column. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleRemoveColumn = async (columnKey) => {
    // Only allow removing dynamic columns
    const column = dynamicColumns.find((col) => col.key === columnKey);
    if (!column) {
      setError("Cannot remove fixed columns.");
      return;
    }

    try {
      setIsLoading(true);

      // Remove column via API
      await removeApplicationColumn(columnKey);

      // Update local state
      setDynamicColumns(dynamicColumns.filter((col) => col.key !== columnKey));
      setColumns(columns.filter((col) => col.key !== columnKey));

      // Update data to remove this column from dynamic_fields
      const updatedData = data.map((row) => {
        const newRow = { ...row };

        if (newRow.dynamic_fields && newRow.dynamic_fields[columnKey]) {
          // Create a new dynamic_fields object without the column
          const { [columnKey]: _, ...restFields } = newRow.dynamic_fields;
          newRow.dynamic_fields = restFields;
        }

        return newRow;
      });

      setData(updatedData);
      setOriginalData(updatedData);
      setSuccessMessage(`Column "${columnKey}" removed successfully.`);
      setTimeout(() => setSuccessMessage(null), 3000);
    } catch (error) {
      console.error("Error removing column:", error);
      setError("Failed to remove column. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilter = (column, type, value) => {
    if (type === "sort") {
      const sortedData = [...data].sort((a, b) => {
        const valA =
          a.dynamic_fields && column in a.dynamic_fields
            ? a.dynamic_fields[column]
            : a[column] || "";

        const valB =
          b.dynamic_fields && column in b.dynamic_fields
            ? b.dynamic_fields[column]
            : b[column] || "";

        if (value === "asc") {
          return valA.toString().localeCompare(valB.toString());
        }
        return valB.toString().localeCompare(valA.toString());
      });
      setData(sortedData);
    } else {
      const filteredData = originalData.filter((row) => {
        const fieldValue =
          row.dynamic_fields && column in row.dynamic_fields
            ? row.dynamic_fields[column]
            : row[column] || "";
        return value.includes(fieldValue.toString());
      });
      setData(filteredData);
    }
  };

  const handleSaveChanges = async () => {
    try {
      setIsLoading(true);

      // Prepare records for bulk update
      const recordsToUpdate = [];
      const recordsToInsert = [];

      // Process all rows
      data.forEach((row, index) => {
        // Skip rows that haven't changed
        if (!changedRows.has(index)) {
          return;
        }

        // Check if this is a new row (hasn't been saved to the server yet)
        if (
          row.id &&
          typeof row.id === "string" &&
          row.id.startsWith("TEMP_")
        ) {
          // Handle new rows for insertion
          const insertRecord = {
            student_name: row.student_name || row.name || "",
            university: row.university || "",
            updates: row.updates || "",
            course_name: row.course_name || "",
            current_status: row.current_status || "",
            offer_received_rejected: row.offer_received_rejected || "",
            location: row.location || "",
            partner: row.partner || "",
            app_fee: row.app_fee || "",
            status: row.status || "",
            country: row.country || "",
            intake: row.intake || null,
            assigned_application_manager:
              row.assigned_application_manager || null,
            dynamic_fields: {},
          };

          // Copy dynamic fields to the dynamic_fields object
          if (row.dynamic_fields && typeof row.dynamic_fields === "object") {
            insertRecord.dynamic_fields = { ...row.dynamic_fields };
          }

          recordsToInsert.push(insertRecord);
        } else {
          // Create update record with the correct structure based on the backend implementation
          const updateRecord = {
            sr_no: row.id, // This is critical - backend uses this to look up records by ID
            name: row.student_name || row.name || "",
            university: row.university || "",
            updates: row.updates || "",
            course_name: row.course_name || "",
            current_status: row.current_status || "",
            offer_received_rejected: row.offer_received_rejected || "",
            location: row.location || "",
            partner: row.partner || "",
            app_fee: row.app_fee || "",
            status: row.status || "",
            country: row.country || "",
            intake: row.intake || null,
            assigned_application_manager:
              row.assigned_application_manager || null,
            dynamic_fields: {},
          };

          // Copy dynamic fields to the dynamic_fields object
          if (row.dynamic_fields && typeof row.dynamic_fields === "object") {
            updateRecord.dynamic_fields = { ...row.dynamic_fields };
          }

          recordsToUpdate.push(updateRecord);
        }
      });

      // Make API calls if we have records to update or insert
      if (recordsToUpdate.length > 0) {
        try {
          const result = await bulkUpdateApplicationRows({
            records: recordsToUpdate,
          });
        } catch (updateError) {
          console.error("Bulk update failed:", updateError);
          setError(`Failed to update changes: ${updateError.message}`);
          setIsLoading(false);
          return; // Exit early on error
        }
      }

      if (recordsToInsert.length > 0) {
        try {
          await bulkInsertApplicationRows({ records: recordsToInsert });
        } catch (insertError) {
          console.error("Insert failed:", insertError);
          setError(`Failed to insert new rows: ${insertError.message}`);
          setIsLoading(false);
          return; // Exit early on error
        }
      }

      // Clear the changed rows set after successful save
      setChangedRows(new Set());

      // Refresh data to get the latest state from the server
      await fetchApplicationData();

      setSuccessMessage("Changes saved successfully!");
      setTimeout(() => setSuccessMessage(null), 3000);
    } catch (error) {
      console.error("Error saving changes:", error);
      setError(`Failed to save changes: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCellChange = (rowIndex, column, value) => {
    // Update the data locally first
    const newData = [...data];
    const row = { ...newData[rowIndex] };

    // Check if this is a dynamic column
    const isDynamicColumn = dynamicColumns.some((col) => col.key === column);

    if (isDynamicColumn) {
      // Ensure dynamic_fields exists
      if (!row.dynamic_fields) {
        row.dynamic_fields = {};
      }

      // Update dynamic field in the dynamic_fields object
      row.dynamic_fields[column] = value;

      // DON'T update the flattened view for dynamic fields
      // This was causing the duplicate status field issue
      // row[column] = value; <-- Remove this line
    } else {
      // If it's a fixed field like 'status', just update it directly
      row[column] = value;
    }

    newData[rowIndex] = row;
    setData(newData);

    // Mark this row as changed
    setChangedRows(new Set(changedRows.add(rowIndex)));
  };

  //delete selected row
  const handleDeleteSelectedRows = async () => {
    if (selectedRows.size === 0) {
      setError("No rows selected for deletion");
      return;
    }

    try {
      setIsLoading(true);

      // Collect IDs of selected rows that are not temporary
      const rowsToDelete = Array.from(selectedRows)
        .map((index) => data[index])
        .filter(
          (row) => row && row.id && !row.id.toString().startsWith("TEMP_")
        )
        .map((row) => row.id);

      if (rowsToDelete.length === 0) {
        // Only temporary rows were selected, just remove them from local data
        const newData = data.filter((_, index) => !selectedRows.has(index));
        setData(newData);
        setOriginalData(newData);
        setSelectedRows(new Set());
        setSuccessMessage("Selected rows removed");
        setTimeout(() => setSuccessMessage(null), 3000);
        return;
      }

      // Delete from server
      await bulkDeleteApplicationRows(rowsToDelete);

      // Remove from local data
      const newData = data.filter((_, index) => !selectedRows.has(index));
      setData(newData);
      setOriginalData(newData);

      // Clear selection
      setSelectedRows(new Set());

      setSuccessMessage(`${rowsToDelete.length} rows deleted successfully`);
      setTimeout(() => setSuccessMessage(null), 3000);
    } catch (error) {
      console.error("Error deleting selected rows:", error);
      setError(`Failed to delete selected rows: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  // First, add this function to your component
  const handleDownloadExcel = () => {
    try {
      setIsLoading(true);

      // Create a new workbook
      const wb = XLSX.utils.book_new();

      // Process the data for export - flatten the dynamic fields
      const exportData = data.map((row, index) => {
        // Create a new object for this row
        const flatRow = {
          "SR. No.": index + 1, // Add the serial number
          ...row, // Include all existing properties
        };

        // Include dynamic fields at the top level
        if (row.dynamic_fields && typeof row.dynamic_fields === "object") {
          Object.entries(row.dynamic_fields).forEach(([key, value]) => {
            flatRow[key] = value;
          });
        }

        // Remove the dynamic_fields object itself to avoid duplication
        delete flatRow.dynamic_fields;

        return flatRow;
      });

      // Convert data to worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, "Application Data");

      // Generate filename with current date
      const now = new Date();
      const filename = `application_data_${
        now.toISOString().split("T")[0]
      }.xlsx`;

      // Export workbook
      XLSX.writeFile(wb, filename);

      setSuccessMessage("Excel file downloaded successfully!");
      setTimeout(() => setSuccessMessage(null), 3000);
    } catch (error) {
      console.error("Error downloading Excel:", error);
      setError(`Failed to download Excel: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const getRowBackgroundColor = (row) => {
    const status = row["status"] || "";
    const statusLower = status.toLowerCase();

    if (statusLower.includes("not applied")) {
      return "bg-red-200 hover:bg-red-300"; // Much darker red
    } else if (statusLower.includes("completed")) {
      return "bg-green-200 hover:bg-green-300"; // Much darker green
    } else if (statusLower.includes("admitted")) {
      return "bg-yellow-200 hover:bg-yellow-300"; // Much darker yellow
    } else if (
      statusLower.includes("default") ||
      statusLower.includes("not started")
    ) {
      return "bg-gray-200 hover:bg-gray-300"; // Much darker gray
    }

    return "bg-white hover:bg-gray-100";
  };

  // Function to get cell value considering dynamic fields
  const getCellValue = (row, columnKey) => {
    // Check if it's a dynamic column and exists in dynamic_fields
    if (
      row.dynamic_fields &&
      typeof row.dynamic_fields === "object" &&
      columnKey in row.dynamic_fields
    ) {
      return row.dynamic_fields[columnKey];
    }

    // Otherwise, return from the main row
    return row[columnKey];
  };

  // Function to render cell safely
  const renderCellValue = (value) => {
    if (value === null || value === undefined) {
      return "";
    }

    if (typeof value === "object") {
      return JSON.stringify(value);
    }

    if (typeof value === "boolean") {
      return value.toString();
    }

    return value;
  };

  const toggleRowSelection = (index) => {
    const newSelected = new Set(selectedRows);
    if (newSelected.has(index)) {
      newSelected.delete(index);
    } else {
      newSelected.add(index);
    }
    setSelectedRows(newSelected);
  };

  // Add a function to select/deselect all rows
  const toggleSelectAll = () => {
    if (selectedRows.size === data.length) {
      // If all rows are selected, deselect all
      setSelectedRows(new Set());
    } else {
      // Otherwise, select all rows
      const allIndices = new Set(data.map((_, index) => index));
      setSelectedRows(allIndices);
    }
  };

  // Function to handle resizing
  const handleResize = (columnKey, newWidth) => {
    setColumnWidths({
      ...columnWidths,
      [columnKey]: `${newWidth}px`,
    });
  };

  // Function to get column width
  const getColumnWidth = (column) => {
    return columnWidths[column.key] || column.width || "150px";
  };

  // Function to reset column widths
  const resetColumnWidths = () => {
    setColumnWidths({});
  };

  // Add this before your return statement
  const ResizableHeader = ({ column, onResize }) => {
    // Get width from state or use default
    const width = parseInt(columnWidths[column.key] || column.width || "150");

    return (
      <Resizable
        width={width}
        height={40} // Fixed height for header
        resizeHandles={["e"]} // East (right) resize handle
        onResize={(e, { size }) => {
          e.preventDefault(); // Prevent default behavior
          onResize(column.key, size.width);
        }}
        draggableOpts={{ enableUserSelectHack: false }}
      >
        <div className="flex h-full items-center justify-between w-full overflow-hidden relative px-4 py-3">
          <span className="truncate flex-grow text-left text-xs font-semibold text-gray-600 uppercase">
            {column.displayName || column.key}
          </span>
          <div className="flex-shrink-0 flex items-center space-x-1">
            {!column.isFixed && (
              <button
                onClick={() => handleRemoveColumn(column.key)}
                className="text-red-500 hover:text-red-700 p-1"
                title="Remove Column"
                disabled={isLoading}
              >
                <FaTimes size={12} />
              </button>
            )}
            <ExcelLikeFilter
              column={column.key}
              data={originalData}
              onFilter={handleFilter}
            />
          </div>

          {/* Custom resize handle styling */}
          <div className="react-resizable-handle react-resizable-handle-e w-2 h-full absolute right-0 top-0 cursor-col-resize group-hover:bg-blue-200 hover:bg-blue-400">
            <div className="w-0.5 h-full bg-gray-300 absolute right-1 top-0 group-hover:bg-blue-500 hover:bg-blue-600"></div>
          </div>
        </div>
      </Resizable>
    );
  };

  return (
    <>
      <style>
        {`
          /* Custom styles for a more sophisticated UI */
          .react-resizable {
            position: relative;
          }
          
          .react-resizable-handle {
            position: absolute;
            width: 10px;
            height: 100%;
            right: 0;
            top: 0;
            cursor: col-resize;
            z-index: 10;
          }
          
          .react-resizable-handle:hover::after,
          .react-resizable-handle-active::after {
            content: "";
            position: absolute;
            width: 2px;
            height: 100%;
            background-color: #3b82f6;
            right: 4px;
          }
          
          /* Table Styling */
          .data-table {
            border-collapse: separate;
            border-spacing: 0;
          }
          
          .data-table th {
            background-color: #f3f4f6;
            border-top: 1px solid #e5e7eb;
            border-bottom: 1px solid #d1d5db;
            position: sticky;
            top: 0;
            z-index: 10;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
          }
          
          .data-table th, .data-table td {
            border-right: 1px solid #e5e7eb;
            border-bottom: 1px solid #e5e7eb;
          }
          
          .data-table th:first-child, .data-table td:first-child {
            border-left: 1px solid #e5e7eb;
          }
          
          .data-table tr:first-child th {
            border-top: 1px solid #d1d5db;
          }
          
          .data-table tr:last-child td {
            border-bottom: 1px solid #d1d5db;
          }
          
          /* Button Styling */
          .btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0.5rem 1rem;
            border-radius: 0.375rem;
            font-weight: 500;
            transition: all 150ms ease;
            gap: 0.5rem;
          }
          
          .btn-primary {
            background-color: #2563eb;
            color: white;
          }
          
          .btn-primary:hover {
            background-color: #1d4ed8;
          }
          
          .btn-primary:disabled {
            background-color: #93c5fd;
            cursor: not-allowed;
          }
          
          .btn-secondary {
            background-color: #4b5563;
            color: white;
          }
          
          .btn-secondary:hover {
            background-color: #374151;
          }
          
          .btn-danger {
            background-color: #dc2626;
            color: white;
          }
          
          .btn-danger:hover {
            background-color: #b91c1c;
          }
          
          .btn-danger:disabled {
            background-color: #fca5a5;
            cursor: not-allowed;
          }
          
          .btn-success {
            background-color: #16a34a;
            color: white;
          }
          
          .btn-success:hover {
            background-color: #15803d;
          }
          
          /* Cell editing styles */
          .editable-cell {
            cursor: pointer;
            transition: background-color 0.2s;
          }
          
          .editable-cell:hover {
            background-color: rgba(59, 130, 246, 0.1);
          }
          
          .changed-cell {
            position: relative;
          }
          
          .changed-cell::after {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 8px 8px 0;
            border-color: transparent #3b82f6 transparent transparent;
          }
        `}
      </style>
      <div
        className={`${
          isSideBarOpen ? "lg:ml-80" : "ml-24"
        } min-h-screen flex flex-col bg-gray-50`}
      >
        {/* Fixed header section with buttons */}
        <div className="bg-white shadow-md py-4 px-6 flex flex-col md:flex-row justify-between items-center sticky top-0 z-20 border-b border-gray-200">
          <div className="mb-4 md:mb-0">
            <h1 className="text-2xl font-bold text-gray-800">
              Application Update Sheet
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              Manage and track student applications
            </p>
          </div>
          <div className="flex flex-wrap gap-3 justify-center md:justify-end">
            {selectedRows.size > 0 && (
              <button
                onClick={handleDeleteSelectedRows}
                className="btn btn-danger"
                disabled={isLoading || selectedRows.size === 0}
              >
                {isLoading ? (
                  <FaSpinner className="animate-spin" />
                ) : (
                  <FaTrash />
                )}{" "}
                Delete Selected ({selectedRows.size})
              </button>
            )}
            <button
              onClick={handleDownloadExcel}
              className="btn btn-success"
              disabled={isLoading || data.length === 0}
            >
              {isLoading ? (
                <FaSpinner className="animate-spin" />
              ) : (
                <FaFileExcel />
              )}{" "}
              Export Excel
            </button>
            <button
              onClick={resetColumnWidths}
              className="btn btn-secondary"
              disabled={isLoading || Object.keys(columnWidths).length === 0}
            >
              <FaArrowsAltH /> Reset Widths
            </button>
            <button
              onClick={() => setRefreshKey((prev) => prev + 1)}
              className="btn btn-secondary"
              disabled={isLoading}
            >
              {isLoading ? (
                <FaSpinner className="animate-spin" />
              ) : (
                <FaSyncAlt />
              )}{" "}
              Refresh
            </button>
            <button
              onClick={handleSaveChanges}
              className="btn btn-primary"
              disabled={isLoading || changedRows.size === 0}
            >
              {isLoading ? <FaSpinner className="animate-spin" /> : <FaSave />}{" "}
              Save Changes {changedRows.size > 0 ? `(${changedRows.size})` : ""}
            </button>
            {/* <button
              onClick={handleAddRow}
              className="btn btn-primary"
              disabled={isLoading || columns.length === 0}
            >
              {isLoading ? <FaSpinner className="animate-spin" /> : <FaPlus />}{" "}
              Add Row
            </button> */}
            <button
              onClick={handleShowAddColumnModal}
              className="btn btn-primary"
              disabled={isLoading}
            >
              {isLoading ? <FaSpinner className="animate-spin" /> : <FaPlus />}{" "}
              Add Column
            </button>
          </div>
        </div>

        {/* Alert messages section */}
        <div className="px-6 py-2">
          {/* Error message display */}
          {error && (
            <div className="bg-red-50 border-l-4 border-red-500 text-red-700 p-4 my-2 rounded shadow-sm">
              <div className="flex">
                <div className="flex-shrink-0">
                  <FaTimes className="h-5 w-5 text-red-500" />
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium">{error}</p>
                </div>
              </div>
            </div>
          )}

          {/* Success message display */}
          {successMessage && (
            <div className="bg-green-50 border-l-4 border-green-500 text-green-700 p-4 my-2 rounded shadow-sm">
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg
                    className="h-5 w-5 text-green-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium">{successMessage}</p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Loading indicator */}
        {isLoading && (
          <div className="flex justify-center items-center p-4 bg-white/80 rounded-lg shadow-sm mx-6 my-2">
            <FaSpinner className="animate-spin text-2xl text-blue-600" />
            <span className="ml-2 font-medium text-gray-700">
              Loading data...
            </span>
          </div>
        )}

        {/* Table container with responsive scroll */}
        <div className="flex-1 overflow-x-auto px-6 py-4">
          <div className="w-full overflow-x-auto rounded-lg shadow-md border border-gray-200 bg-white">
            <table className="w-full data-table">
              <thead>
                <tr>
                  {/* Selection checkbox */}
                  <th
                    className="sticky top-0 z-10 bg-gray-100 text-center border-r border-gray-300"
                    style={{ width: "60px", minWidth: "60px" }}
                  >
                    <div className="flex flex-col items-center p-3">
                      <span className="mb-1 text-xs font-semibold text-gray-600 uppercase">
                        Select
                      </span>
                      <input
                        type="checkbox"
                        checked={
                          selectedRows.size === data.length && data.length > 0
                        }
                        onChange={toggleSelectAll}
                        className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                      />
                    </div>
                  </th>

                  {/* SR No. column */}
                  <th
                    className="sticky top-0 z-10 bg-gray-100 text-left p-3 border-r border-gray-300"
                    style={{ width: "80px", minWidth: "80px" }}
                  >
                    <div className="text-xs font-semibold text-gray-600 uppercase">
                      SR No.
                    </div>
                  </th>

                  {visibleColumns.map((col, index) => (
                    <th
                      key={index}
                      className="p-0 sticky top-0 z-10 bg-gray-100 border-r border-gray-300"
                    >
                      <Resizable
                        width={parseInt(getColumnWidth(col))}
                        height={46}
                        resizeHandles={["e"]}
                        onResize={(e, { size }) => {
                          e.preventDefault();
                          handleResize(col.key, size.width);
                        }}
                        handle={
                          <div
                            className="absolute right-0 top-0 h-full w-3 cursor-col-resize z-10 hover:bg-blue-100"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="absolute right-1 top-0 h-full w-0.5 bg-gray-300 hover:bg-blue-500"></div>
                          </div>
                        }
                      >
                        <div className="h-full p-3 flex items-center justify-between overflow-hidden">
                          <span className="truncate flex-grow text-xs font-semibold text-gray-600 uppercase">
                            {col.displayName || col.key}
                          </span>
                          <div className="flex-shrink-0 flex items-center space-x-1">
                            {!col.isFixed && (
                              <button
                                onClick={() => handleRemoveColumn(col.key)}
                                className="text-red-500 hover:text-red-700 p-1 rounded-full hover:bg-red-50"
                                title="Remove Column"
                                disabled={isLoading}
                              >
                                <FaTimes size={12} />
                              </button>
                            )}
                            <ExcelLikeFilter
                              column={col.key}
                              data={originalData}
                              onFilter={handleFilter}
                            />
                          </div>
                        </div>
                      </Resizable>
                    </th>
                  ))}
                  <th
                    className="sticky top-0 z-10 bg-gray-100 text-center p-3 border-r border-gray-300"
                    style={{ width: "100px", minWidth: "100px" }}
                  >
                    <div className="text-xs font-semibold text-gray-600 uppercase">
                      Actions
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.length === 0 && !isLoading ? (
                  <tr>
                    <td
                      colSpan={visibleColumns.length + 3}
                      className="px-6 py-10 text-center text-gray-500 border"
                    >
                      <div className="flex flex-col items-center justify-center">
                        <FaSearch className="text-3xl text-gray-300 mb-3" />
                        <p className="text-base">No application data found</p>
                        <p className="text-sm mt-1">
                          Add a new row to get started or refresh the data
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : columns.length === 0 && !isLoading ? (
                  <tr>
                    <td
                      colSpan={3}
                      className="px-6 py-10 text-center text-gray-500 border"
                    >
                      <div className="flex flex-col items-center justify-center">
                        <FaFilter className="text-3xl text-gray-300 mb-3" />
                        <p className="text-base">No columns defined</p>
                        <p className="text-sm mt-1">
                          Data structure may be empty or invalid
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  data.map((row, rowIndex) => {
                    const rowBackgroundClass = getRowBackgroundColor(row);
                    return (
                      <tr
                        key={rowIndex}
                        className={`${rowBackgroundClass} ${
                          selectedRows.has(rowIndex) ? "bg-blue-50" : ""
                        } transition-colors duration-200`}
                      >
                        {/* Selection checkbox */}
                        <td className="px-3 py-3 border text-center">
                          <input
                            type="checkbox"
                            checked={selectedRows.has(rowIndex)}
                            onChange={() => toggleRowSelection(rowIndex)}
                            className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                            onClick={(e) => e.stopPropagation()}
                          />
                        </td>

                        {/* SR No. column */}
                        <td className="px-3 py-3 border text-sm font-medium text-gray-700">
                          {rowIndex + 1}
                        </td>

                        {visibleColumns.map((col, colIndex) => (
                          <td
                            key={colIndex}
                            className={`border text-sm ${
                              changedRows.has(rowIndex) ? "changed-cell" : ""
                            } editable-cell`}
                            style={{
                              minWidth: col.minWidth,
                              width: getColumnWidth(col),
                              maxWidth: getColumnWidth(col),
                            }}
                            onClick={() =>
                              setEditingCell({ row: rowIndex, col: col.key })
                            }
                          >
                            {editingCell?.row === rowIndex &&
                            editingCell?.col === col.key ? (
                              <input
                                type="text"
                                value={
                                  renderCellValue(getCellValue(row, col.key)) ||
                                  ""
                                }
                                onChange={(e) => {
                                  handleCellChange(
                                    rowIndex,
                                    col.key,
                                    e.target.value
                                  );
                                }}
                                onBlur={() => setEditingCell(null)}
                                className="w-full p-2 border-0 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                                autoFocus
                              />
                            ) : (
                              <div className="px-3 py-3 overflow-hidden text-ellipsis">
                                <span
                                  className={
                                    changedRows.has(rowIndex)
                                      ? "font-medium text-blue-600"
                                      : "text-gray-700"
                                  }
                                >
                                  {renderCellValue(getCellValue(row, col.key))}
                                </span>
                              </div>
                            )}
                          </td>
                        ))}
                        <td
                          className="px-3 py-3 border text-center"
                          style={{ width: "100px", minWidth: "100px" }}
                        >
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteRow(rowIndex);
                            }}
                            className="text-red-500 hover:text-red-700 hover:bg-red-50 p-2 rounded-full transition-colors duration-200 disabled:text-red-300 disabled:cursor-not-allowed"
                            title="Delete Row"
                            disabled={isLoading}
                          >
                            <FaTrash size={14} />
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Add Column Modal */}
        {showAddColumnModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
              <div className="border-b border-gray-200 px-6 py-4">
                <h3 className="text-lg font-medium text-gray-900">
                  Add New Column
                </h3>
              </div>

              <div className="p-6">
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Column Name
                  </label>
                  <input
                    type="text"
                    value={newColumnName}
                    onChange={(e) => setNewColumnName(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter column name"
                  />
                </div>

                <div className="flex justify-end space-x-3 mt-6">
                  <button
                    onClick={() => setShowAddColumnModal(false)}
                    className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleAddColumn}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-blue-300"
                    disabled={!newColumnName.trim() || isLoading}
                  >
                    {isLoading ? (
                      <FaSpinner className="animate-spin mx-auto" />
                    ) : (
                      "Add Column"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ApplicationData;
